// Mirrors the server-side defaults in _phase_duration (backend/server.py).
// Single source of truth for timer labels and defaults — used by GameSettingsPanel
// and any page that renders or syncs clock settings.
//
// `draftOnly`: timer is only meaningful when the matching draft toggle is on,
// so GameSettingsPanel hides the input until the host enables the draft.
export const TIMER_META = {
  pitch_clock_secs:       { label: "Pitch + Batting",  default: 30, max: 120 },
  pitch_pitcher_secs:     { label: "Pitching",         default: 30, max: 120 },
  pitch_batter_secs:      { label: "Batting",          default: 30, max: 120 },
  fielding_clock_secs:    { label: "Fielding",         default: 30, max: 120 },
  steal_clock_secs:       { label: "Steal Attempt",    default: 30, max: 120 },
  hand_refresh_secs:      { label: "Card Trade-Back",  default: 30, max: 120 },
  pickoff_select_secs:    { label: "Pickoff Select",   default: 15, max: 60  },
  // Shared timer for the small card-action modals — Student of the Game,
  // Stealing Signals (peek + decide), Manager's Decision, Subterfuge Steal,
  // Hidden Ball Trick target, and Bluff Values assignment.
  card_modal_secs:        { label: "Card Action Modal", default: 20, max: 60 },
  swap_spit_secs:         { label: "Swap & Spit",       default: 20, max: 60 },
  draft_pick_secs:        { label: "Deck Draft Pick",   default: 30, max: 120, draftOnly: "draft_enabled" },
  player_draft_pick_secs: { label: "Player Draft Pick", default: 45, max: 120, draftOnly: "player_draft_enabled" },
};

export const TIMER_KEYS = Object.keys(TIMER_META);
